import { StyleSheet } from 'react-native';

import { mediaQueryValues } from '../../../media-query';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  image: {
    marginBottom: -16,
    marginTop: mediaQuery.small,
  },
  question: {
    marginTop: 16,
    textAlign: 'center',
  },
  optionContainer: {
    width: '100%',
  },
  audioPlayer: {
    paddingBottom: 0,
  },
});
